// TYPES
import { SET_MY_USER, REQUEST_MY_USER } from "../constants/actionTypes";
import { USER } from "../constants/initialStates";

// API
import API from "../api";

// ACTIONS
// ----------------------------------------------------------------
export function setUser({ id, username, f, i, o, email }) {
  return {
    type: SET_MY_USER,
    user: {
      item: { id, username, f, i, o, email },
      isFetching: false
    }
  };
}

export function requestMyUser() {
  return {
    type: REQUEST_MY_USER
  };
}

export function fetchMyUser() {
  return async dispatch => {
    dispatch(requestMyUser());

    const meInfo = await API.me.getInfo();

    dispatch(setUser(meInfo || USER.item));
    return meInfo || USER.item;
  };
}

function shouldFetchMyUser({ user }) {
  if (!user || !user.item) {
    console.log("!user || !user.item");
    return true;
  } else if (user.item.id === "" && !user.isFetching) {
    return true;
  } else {
    return false;
  }
}

export function fetchMyUserIfNeeded() {
  return async (dispatch, getState) => {
    if (shouldFetchMyUser(getState())) {
      return await dispatch(fetchMyUser());
    }
  };
}
// ----------------------------------------------------------------
